<template>
	<div class="db2-equip" :class="'is-' + variant">
		<template v-if="variant === 'icons'">
			<div class="db2-equip-icon" v-for="item in items" :key="item.name">
				<v-icon :class="item.iconClass">{{ item.icon }}</v-icon>
				<div class="db2-equip-copy">
					<div class="name">{{ item.name }}</div>
					<div class="status is-ok">{{ item.status }}</div>
				</div>
			</div>
		</template>
		<template v-else>
			<div class="db2-equip-tile" v-for="item in items" :key="item.name">
				<div class="name">{{ item.name }}</div>
				<div class="metric">{{ item.metric }}</div>
				<div class="value">{{ item.value }}</div>
				<div class="status" :class="item.status === 'Normal' ? 'is-ok' : 'is-warn'">{{ item.status }}</div>
			</div>
		</template>
	</div>
</template>

<script>
import { mockPointData } from '../mockPointData';

const ICON_ITEMS = [
		{ name: 'HVAC', icon: 'mdi-snowflake' },
		{ name: 'Ventilation', icon: 'mdi-fan' },
		{ name: 'Lighting', icon: 'mdi-lightbulb-outline' },
		{ name: 'Electrical', icon: 'mdi-flash-outline' },
		{ name: 'Plumbing', icon: 'mdi-water-outline', iconClass: 'is-drop' },
		{ name: 'Fire Safety', icon: 'mdi-shield-outline' },
		{ name: 'Security', icon: 'mdi-lock-outline' }
];

const TILE_ITEMS = [
	{ name: 'AHU-1', metric: 'Supply Air Temp' },
	{ name: 'AHU-2', metric: 'Supply Air Temp' },
	{ name: 'AHU-3', metric: 'Supply Air Temp' },
	{ name: 'Chiller Plant', metric: 'Leaving Water' },
	{ name: 'Boiler Plant', metric: 'Hot Water' },
	{ name: 'Ventilation', metric: 'OA Damper' }
];

/**
 * Equipment tiles or system icon grid.
 */
export default {
	name: 'EquipmentCard',
	props: {
		card: { type: Object, required: true },
		timePeriod: { type: String, default: 'week' },
		refreshKey: { type: Number, default: 0 }
	},
	computed: {
		/**
		 * Variant.
		 * @returns {string}
		 */
		variant() {
			return (this.card.config && this.card.config.variant) || 'icons';
		},
		/**
		 * Display items with mock values.
		 * @returns {Array}
		 */
		items() {
			if (this.variant === 'icons') {
				return ICON_ITEMS.map(it => ({ ...it, status: 'Normal' }));
			}
			return TILE_ITEMS.map((it, i) => {
				const d = mockPointData(this.card.uniqueId + '-' + i, this.timePeriod, { unit: '°F', base: 52, refreshKey: this.refreshKey });
				return {
					...it,
					value: d.value + ' °F',
					status: d.value > 58 ? 'Warning' : 'Normal'
				};
			});
		}
	}
};
</script>
